import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';




import { Constantes } from '../../compartido/constantes/constantes';
import { MensajesConstantes } from '../../compartido/constantes/mensajes';
import { CustomHttp } from '../../compartido/customHttp/CustomHttp';
import { UCuencaError } from '../../compartido/errores/UCuencaError';
import { UCuencaErrorHandler } from '../../compartido/errores/UCuencaErrorHandler';

@Injectable()
export class ControlaRutaService {

  private NOMBRE_SERVICIO = '/controla-ruta';

  private BASE_URL = Constantes.URL_SERVER_SAR;
  
  private errorHandler: UCuencaErrorHandler = new UCuencaErrorHandler();


  constructor(private http: CustomHttp) {

   }


   /**
   * 
   * @param idConvenio 
   */
  permiteAcceso(idAplicativo: string, idUnidad: number, ruta: string): Observable<boolean> {    

    let rutaEncode = encodeURI(ruta);
    
    /**
     * Remplaza los /  por punto y coma para q no exita error al buscar la ruta
     */
   
  
   let rutaTransforma = ruta.replace(/\//g,'slash');
   console.log('ruta transforma ' + rutaTransforma);
   

    const url = this.BASE_URL + this.NOMBRE_SERVICIO + '/validar/' + idAplicativo + '/' + idUnidad + '/'+ rutaTransforma ;
    console.log('mostrando url ' + url);

    return this.http.get(url).map( (r: Response) => {
        if (r.status === 200) {
          if (r.json().status == 'OK') {

            let objConvenio: boolean = r.json().objeto as boolean;
            return objConvenio;

          } else {
            throw new UCuencaError('ERROR: ' + r.json().message);
          }
        } else {
          throw new UCuencaError(MensajesConstantes._servicioNoDisponible, r.status);
        }
      })
      .catch(this.errorHandler.handleError);
  }
}


